import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { tableNames } from '../../app/app.constants';
import { GlobalVars } from '../../app/app.environment';
import { Area } from '../../models/area';
import { FirebaseProvider } from '../firebase/firebase';


@Injectable()
export class AreaProvider {

  constructor(
    public firebaseService: FirebaseProvider,
    public globalVars: GlobalVars,
  ) {}

  getAllAreas(): Observable<Area[]> {
    return this.firebaseService.list(this.getBaseRoot())
  }

  getAllAreasOnce(): Observable<Area[]> {
    return this.firebaseService.listOnce(this.getBaseRoot())
  }

  getAllVisibleAreas(): Observable<Area[]> {
    return this.firebaseService.list(this.getBaseRoot()).map(areas => areas.filter(area => area.visible))
  }

  getAllVisibleAreasOnce(): Observable<Area[]> {
    return this.firebaseService.listOnce(this.getBaseRoot()).map(areas => areas.filter(area => area.visible))
  }

  getArea(areaId: string): Observable<Area> {
    return this.firebaseService.object(this.getBaseRoot() + areaId);
  }

  getAreaOnce(areaId: string): Observable<Area> {
    return this.firebaseService.objectOnce(this.getBaseRoot() + areaId);
  }

  getAreas(): Observable<Area[]> {
    return this.firebaseService.list(this.getBaseRoot())
      .map(areas => areas.filter(area => area.visible == true))
  }

  getAreasOnce(): Observable<Area[]> {
    return this.firebaseService.listOnce(this.getBaseRoot())
      .map(areas => areas.filter(area => area.visible == true))
  }

  remove(areaId): Promise<any> {
    return this.firebaseService.remove(this.getBaseRoot(), areaId)
  }

  save(area: Area): Promise<any> {
    if (area.key) {
      var key = area.key;
      delete area.key;
      return this.firebaseService.set(this.getBaseRoot(), key, area)
    }
      
    else return this.firebaseService.push(this.getBaseRoot(), area)
  }

  /**
   * Arrel base dins la base de dades.
   */
  private getBaseRoot(): string {
    return tableNames.Repo + '/' + this.globalVars.user.repo + '/' + tableNames.Areas + '/';
  }

}



// WEBPACK FOOTER //
// ./src/providers/area/area.ts